import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faThLarge,
  faUsers,
  faUserGraduate,
  faBookOpen,
  faCalendar,
  faBook,
  faClipboardList,
  faFileCode,
  faMoneyBillWave,
  faTicketAlt,
  faWallet,
  faShoppingCart,
  faComments,
  faFlag,
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';
import { authService } from '../utils/api';

interface SidebarProps {
  onClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const navigation = [
    { name: 'لوحة التحكم', href: '/', icon: faThLarge },
    { name: 'مستخدمي النظام', href: '/system-users', icon: faUsers },
    { name: 'الطلاب', href: '/students', icon: faUserGraduate },
    { name: 'الباقات', href: '/courses', icon: faBookOpen },
    { name: 'حصص السنتر', href: '/sessions', icon: faCalendar },
    { name: 'الكتب', href: '/books', icon: faBook },
    { name: 'أكواد المحاضرات', href: '/unit-codes', icon: faClipboardList },
    { name: 'أكواد الباقات', href: '/codes', icon: faFileCode },
    { name: 'التحويلات', href: '/transactions', icon: faMoneyBillWave },
    { name: 'أكواد الخصم', href: '/promo-codes', icon: faTicketAlt },
    { name: 'أكواد شحن المحفظة', href: '/wallet-codes', icon: faWallet },
    { name: 'الطلبات', href: '/orders', icon: faShoppingCart },
    { name: 'اتصل بنا', href: '/contact-us', icon: faComments },
    { name: 'إبلاغ للمؤلف', href: '/flag-to-author', icon: faFlag },
  ];

  const handleLogout = async () => {
    try {
      console.log('Starting logout process...');
      await authService.logout();
      console.log('Logout completed, navigating to login...');
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      await authService.logout();
      navigate('/login');
    }
  };

  return (
    <div className="w-64 h-full bg-gray-50 shadow-lg flex flex-col" dir="rtl">
      <div className="px-4 py-6 border-b border-gray-200 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <h1 className="text-xl font-bold text-gray-800">لوحة الإدارة</h1>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="lg:hidden p-2 text-gray-600 hover:bg-gray-200 rounded-md transition-colors"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
      
      <nav className="flex-1 px-2 py-4 overflow-y-auto">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href;
          return (
            <Link
              key={item.name}
              to={item.href}
              onClick={() => onClose && onClose()}
              className={`flex items-center px-4 py-3.5 mb-1 rounded-lg transition-all duration-200 text-[15px] font-medium ${
                isActive
                  ? 'bg-amber-500 text-white'
                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800'
              }`}
              title={item.name}
            >
              <FontAwesomeIcon 
                icon={item.icon} 
                className={`w-5 h-5 ml-3.5 flex-shrink-0 ${
                  isActive ? 'text-white' : 'text-gray-500'
                }`}
              />
              <span className="flex-1">{item.name}</span>
            </Link>
          );
        })}
      </nav>
      
      <div className="px-2 py-4 border-t border-gray-200">
        <button
          onClick={handleLogout}
          className="flex items-center w-full px-4 py-3.5 text-gray-600 hover:bg-gray-100 hover:text-gray-800 rounded-lg transition-all duration-200 text-[15px] font-medium"
          title="تسجيل الخروج"
        >
          <FontAwesomeIcon 
            icon={faSignOutAlt} 
            className="w-5 h-5 ml-3.5 flex-shrink-0 text-gray-500"
          />
          <span className="flex-1">تسجيل الخروج</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;